import Richtext from '@streamfields/Richtext';

import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/splide.min.css';
import Link from 'next/link';
import { WagtailPage } from '@/types';
import { removeBaseUrl } from '@/utils/url';

import BonusweltCompany from '@components/BonusweltCompany';
import { Company } from './models';

interface Props {
  title: string;
  description: string;
  overview_page: WagtailPage;
  companies: Record<'company', Company>[];
}

function BonusweltSlider(props: Props) {
  const { companies, description, title, overview_page: overviewPage } = props;
  const mappedCompanies = companies.map(c => c.company);

  return (
    <div className='bonuswelt'>
      <div className='bonuswelt__before_slide'>
        <h2 className='bonuswelt__title'>{title}</h2>
        <div className='bonuswelt__description'>
          <Richtext sourcecode={description} />
        </div>
      </div>
      <div className='bonuswelt__splide'>
        <Splide
          options={{
            mediaQuery: 'min',
            rewind: true,
            gap: '20px',
            arrowPath: 'm 13.000027,8 14,11.994 -14,12.006',
            perPage: 1,
            arrows: false,
            padding: { left: 0, right: 60 },
            breakpoints: {
              640: {
                perPage: 2,
                padding: '0',
              },
              820: {
                arrows: companies.length > 2,
              },
              1200: {
                perPage: 3,
                arrows: companies.length > 3,
              },
            },
          }}
        >
          {mappedCompanies.map(company => (
            <SplideSlide key={company.id}>
              <BonusweltCompany company={company} />
            </SplideSlide>
          ))}
        </Splide>
      </div>

      <div className='bonuswelt__after_slide'>
        {overviewPage ? (
          <div className='bonuswelt__button_uebersicht'>
            <Link href={removeBaseUrl(overviewPage.full_url)} className='button button--primary'>
              Zur Angebotsübersicht
            </Link>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default BonusweltSlider;
